
import Vue from 'vue'
import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'


export const MODULE_NAME = 'publications.storage'

export const createPublicationStorageModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "PublicationStorageModal" */
    './components/PublicationStorageModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createPublicationStorageReportModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "PublicationStorageReportModal" */
    './components/PublicationStorageReportModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
